import { useOutletContext } from 'react-router-dom';

import { snakeToTitleCase } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Switch from 'components/shared/Switch/Switch';

const ClinicalNotesSettings = () => {
  const { clinicalNoteSections, practice, handleChange, updateDisabled } = useOutletContext();

  return (
    <div className="overflow-auto !pr-1">
      <p className="pb-1 text-lg font-600 text-neutral-700">Clinical Notes</p>
      <div className="grid grid-cols-2 gap-4">
        {Object.keys({
          ...clinicalNoteSections,
          ...practice?.display_settings?.clinical_notes
        }).map((key) => {
          return (
            <div
              className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3"
              key={key}>
              <div>{snakeToTitleCase(key)}</div>
              <Switch
                onChange={() =>
                  handleChange('clinical_notes', {
                    ...practice?.display_settings?.clinical_notes,
                    [key]: !practice?.display_settings?.clinical_notes[key]
                  })
                }
                checked={
                  practice?.display_settings?.clinical_notes
                    ? practice?.display_settings?.clinical_notes[key]
                    : true
                }
                disabled={updateDisabled}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default withErrorBoundary(ClinicalNotesSettings);
